import ProductDetails from "../product-details";
import PropTypes from "prop-types";
import { TAB_NAMES } from "./product-info";
import ReviewsPreview from "components/source/universal_pdp/reviews/reviews-preview/reviews-preview";
import SizeGuideTab from "./size-guide-tab";

export default function Body(props) {
  const { tabSelected, logReadAllReviews, isBuyNow, isMobileViewport, enableSizeGuide } = props;
  return (
    <div className="pdp-product-info__display-space">
      {tabSelected === TAB_NAMES.reviews && (
        <ReviewsPreview logReadAllReviews={logReadAllReviews} productId={props?.productId} />
      )}
      {tabSelected === TAB_NAMES.product_details && (
        <ProductDetails
          showOptionalDetails={isBuyNow}
          isMobileViewport={isMobileViewport}
          imageRotation={props?.imageRotation}
          images={props?.images}
          displayName={props?.displayName}
          designerDisplayName={props?.designerDisplayName}
          productId={props?.productId}
          fitNotes={props?.fitNotes}
          stylistNotes={props?.stylistNotes}
          productDetails={props?.productDetails}
        />
      )}
      {tabSelected === TAB_NAMES.size_guide && enableSizeGuide && (
        <SizeGuideTab designerName={props?.designerDisplayName} designerNotes={props?.fitNotes} productId={"WWW39"} />
      )}
    </div>
  );
}

Body.propTypes = {
  images: PropTypes.object,
  imageRotation: PropTypes.arrayOf(PropTypes.object),
  displayName: PropTypes.string,
  designerDisplayName: PropTypes.string,
  productId: PropTypes.string,
  fitNotes: PropTypes.string,
  stylistNotes: PropTypes.string,
  productDetails: PropTypes.string,
  logReadAllReviews: PropTypes.func,
  tabSelected: PropTypes.string,
  isBuyNow: PropTypes.bool,
  isMobileViewport: PropTypes.bool,
  enableSizeGuide: PropTypes.bool,
};
